import { useDispatch, useSelector } from "react-redux";
import {Typography} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import FiltersSection from "../../Filters/FiltersSection";
import {makeStyles} from "@material-ui/core/styles";
import { getOSMovimentadasDetalhado} from "../../../actions/orderActions"
import {getEtapas} from "../../../actions/stationActions";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import EtapaFoto from "../FotografiaPlanta/EtapaFoto";
import OSBarras from "./OSBarras";


const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    listaOS: {
      flex: 1,
      flexDirection: "row",
      flexWrap: "wrap"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const MovimentacaoOS = ({

                    }) => {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const st = useSelector(state => state);
    console.log("REDUX STATE", st)
    const etapas = useSelector(state => state.stations.etapas);
    const movimentacaoOS = useSelector(state => state.ordemServicoReducer.movimentadasPeriodoDetalhada);
    const isFetchingOSMovimentadas = useSelector(state => state.ordemServicoReducer.isFetchingOSMovimentadas);
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);

    const dispatch = useDispatch();

    useEffect( () => {
        console.log("useEffect 0,0 getdiarioProducao");
        dispatch(getEtapas());
        dispatch(getOSMovimentadasDetalhado());
    }, []);

    // useEffect(() => {
    //     dispatch(getOSMovimentadasDetalhado());
    // }, [periodMin]);
    //
    // useEffect(() => {
    //     dispatch(getOSMovimentadasDetalhado());
    // }, [periodMax]);

    const onFilterClick = () => {
        dispatch(getOSMovimentadasDetalhado());
    }



    ////



    let acabec = [];


    etapas
        .sort(function (a, b) {
            var aSize = 1; //a.estabelecimentoId;
            var bSize = 1; //b.estabelecimentoId;
            var aLow = a.sequencia;
            var bLow = b.sequencia;
            // console.log(aLow + " | " + bLow);

            if(aSize == bSize)
            {
                return (aLow < bLow) ? -1 : (aLow > bLow) ? 1 : 0;
            }
            else
            {
                return (aSize < bSize) ? -1 : 1;
            }
        })
        .map((e) => {
        acabec.push({ label:e.descricao, abreviatura: e.abreviatura, count: 0  })
    })
    acabec.push({ label:'OUTROS', abreviatura: 'OUTROS', count: 0  })
    acabec.push({ label:'FINAL', abreviatura: 'FINAL', count: 1  })
    //diario.push(acabec);







   // console.log("diario", diario);

    console.log("reducer movimentacaoOS", movimentacaoOS);

    return (
        <React.Fragment>
            <Grid container direction="column" className={classes.dashboardSection}>
                <Grid item xs={12}>
                    <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false}  onFilterClick={onFilterClick} loading={isFetchingOSMovimentadas} />
                </Grid>
            </Grid>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>

                <Typography variant="h4" align="center" className={classes.sectionTitle}>
                    ORDENS DE SERVIÇO MOVIMENTADAS NO PERIODO
                </Typography>


            </Grid>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>
                <Grid container className={classes.listaOS}>

                    { !isFetchingOSMovimentadas  && movimentacaoOS.length > 0 &&
                        <React.Fragment>
                            { movimentacaoOS
                                .map( (e, ix) => {

                                    return (<OSBarras key={ix} os={e} index={ix}/> );
                                }) }
                        </React.Fragment>

                    }
                </Grid>

                { isFetchingOSMovimentadas &&
                    <React.Fragment>
                        <CircularProgress color="primary" />
                    </React.Fragment>
                }
            </Grid>
        </React.Fragment>
    )

}

export default MovimentacaoOS;
